import type { PhotoLink } from "@/lib/api/types"
import { sideBucket } from "./catalog"

// The photo ↔ line link, read from the wire. A line "appears under" the
// photos that show it. One component on one side is one line, however
// many photos it appears under — `lineKey` is that identity.

/** The links on a line item, or none. Tolerant of a missing/odd payload. */
export function photoLinksOf(li: { metadata?: Record<string, unknown> | null }): PhotoLink[] {
  const raw = li.metadata?.photos
  if (!Array.isArray(raw)) return []
  return raw.filter(
    (p): p is PhotoLink => !!p && typeof p === "object" && typeof (p as PhotoLink).imageId === "number",
  )
}

/** Dedupe identity: the same component on the same side is the same line. */
export function lineKey(component: string, side: string | null | undefined): string {
  return `${component}::${sideBucket(side)}`
}
